/**
 * Geotab adapter — IOT-ADAPTER-LIBRARY-1.
 *
 * Tier: third-party-tier-1 (largest commercial telematics platform globally)
 * Category: fleet_telematics
 *
 * TYPE-ONLY: capability matrix declared; live API calls (Geotab SDK / MyGeotab
 * REST) throw VendorNotIntegratedError. Full integration scheduled for a
 * follow-on session once MyGeotab API credentials are provisioned.
 *
 * Supported devices: Geotab GO9, GO9+, GO9 RUGGED. Capability surface below
 * is the union — model-specific subsets enforced at integration time.
 *
 * Patent anchor: F-IOT-ADAPTER-001.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const GEOTAB_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: true,
      readable: true,
      range: [1, 3600],
      requiresActivation: false,
      unit: 'seconds',
      description: 'Position / status reporting interval',
    },
    harsh_event_thresholds: {
      pushable: true,
      readable: true,
      requiresActivation: false,
      description: 'Acceleration / cornering / braking thresholds (compound JSON value)',
    },
    iox_aux_enabled: {
      pushable: false,
      readable: true,
      enum: ['true', 'false'],
      requiresActivation: true,
      description: 'IOX Add-on Auxiliary device enablement (provisioning-time)',
    },
  },
  telemetryTypes: [
    'gps_position', 'speed_kph', 'heading_deg', 'odometer_km', 'engine_rpm',
    'fuel_level_pct', 'battery_voltage_v', 'cell_signal_dbm',
  ],
  alertingMode: 'onboard',
  otaSupported: true,
  attestationSupported: true,
  rollbackSupported: true,
  pushLatencyExpectedMs: 10_000,
};

export class GeotabAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'geotab', GEOTAB_CAPABILITIES);
  }
}

export function createGeotabAdapterFactory() {
  return (device) => new GeotabAdapter(device);
}
